import "../../src/assets/fonts/icomoon/style.css";

import React from "react";
import { createRef, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import clientComponent from "../config/clientComponents";
import windowSize from "../utils/windowSize";
import Map from "./Map";
import OverlayHeader from "./OverlayHeader";
import Sidebar from "./Sidebar";
import { dataCheck } from "../utils/dataCheck";
import { logRoles } from "@testing-library/react";

const GlanumLeaflet = ({ data }) => {
  const { t, i18n } = useTranslation();

  //--- Filter the entities that doesn't have long/lat data
  let filteredData = [];
  let displayErrors = document.getElementById("root").dataset.errors;
  //let displayErrors = true;

  const verifiedEntities = dataCheck(data, displayErrors);

  //--- Get pre-filter to apply on page loading if needed
  if (process.env.REACT_APP_ALPHABETIC_DATA === "true") {
    filteredData = verifiedEntities.sort((itemOne, itemSecond) => itemOne.name.localeCompare(itemSecond.name));
  } else if (process.env.REACT_APP_DATE_DATA === "true") {
    filteredData = verifiedEntities.sort((itemOne, itemSecond) => {
      return itemSecond.post_date.localeCompare(itemOne.post_date);
    });
  } else {
    filteredData = verifiedEntities;
  }
  let dataPreFilter = document.getElementById("root").dataset.filter;
  if (dataPreFilter) {
    dataPreFilter = JSON.parse(dataPreFilter);
  }

  //--- Get filters and pre-filters keys
  let filtersKeys = [];
  if (data.filters) {
    filtersKeys = Object.keys(data.filters);
  }
  let preselectedFiltersKeys = [];
  if (dataPreFilter) {
    preselectedFiltersKeys = Object.keys(dataPreFilter);
  }
  const [isFocused, setIsFocused] = useState(false);
  const [townDefaultValue, setTownDefaultValue] = useState("");
  const [filtersState, setFiltersState] = useState({});
  console.log(filtersState);
  const [selectedInstitution, setSelectedInstitution] = useState();

  const [filteredEntities, setFilteredEntities] = useState(filteredData);

  const [searchState, setSearchState] = useState("");
  const [locationSearch, setLocationSearch] = useState("");
  const [filterScreen, setFilterScreen] = useState(false);
  const [mapScreen, setMapScreen] = useState(false);
  const [scrollbarRef, setScrollbarRef] = useState({});
  const [sizeState, setSizeState] = useState(() => {
    return window.innerWidth;
  });
  const [showFiltersFrom, setShowFiltersFrom] = useState(null);
  const [userCurrentPosition, setUserCurrentPosition] = useState(null);
  const [geoSearch, setGeoSearch] = useState(null);
  const [selectedGeoAdress, setSelectedGeoAdress] = useState(null);
  const [mapRef, setMapRef] = useState(null);
  const legende = data?.legende 
  //--- Institution item refs to allow scroll
  const lineRefs = useRef([]);
  lineRefs.current = data.entities.map(
    (_, i) => lineRefs.current[i] ?? createRef()
  );

  const customMarkerRefs = useRef([]);
  customMarkerRefs.current = data.entities.map(
    (_, i) => customMarkerRefs.current[i] ?? createRef()
  );

  const popupRefs = useRef([]);
  popupRefs.current = data.entities.map(
    (_, i) => popupRefs.current[i] ?? createRef()
  );

  // const mapRef = useRef(null);

  //--- Initialisation de l'objets Filtres
  useEffect(() => {
    windowSize(sizeState, setSizeState);
    for (const filterKey of filtersKeys) {
      setFiltersState((prevState) => ({
        ...prevState,
        [filterKey]: [],
      }));
    }


    // filters default value using data
    if (process.env.REACT_APP_DEFAULT_VALUE === "true") {
      const filtersData = data.filters
      const selectedSlugMapping = {};
      
      for (const key in filtersData) {
        if (filtersData[key]?.selected !== undefined && filtersData[key]?.selected?.toString().length > 0) {
          selectedSlugMapping[filtersData[key].slug] = [filtersData[key].selected];
        }
      }
      for (const filterKey of filtersKeys) {
        if (selectedSlugMapping[filterKey] && selectedSlugMapping[filterKey][0] !== 0) {
          setFiltersState((prevState) => ({
            ...prevState,
            [filterKey]: selectedSlugMapping[filterKey] ?? [],
          }));
        }
      }
      if (selectedSlugMapping?.town) {
        setTownDefaultValue(selectedSlugMapping?.town[0])
        setLocationSearch(selectedSlugMapping?.town[0])
        const selectedGeoAdress = {
          "type": "Feature",
          "geometry": {
            "type": "Point",
            "coordinates": [
              filtersData.town.lat,
              filtersData.town.long
            ]
          },
          "properties": {
            "label": selectedSlugMapping?.town[0],
            "id": "999999",
            "name": selectedSlugMapping?.town[0],
            "city": selectedSlugMapping?.town[0],
          }
        }
        setSelectedGeoAdress(selectedGeoAdress)
      }
    }


    //--- Set up the filter state with the pre-filter
    if (dataPreFilter) {
      for (const preselectedFilterKey of preselectedFiltersKeys) {
        setFiltersState((prevState) => ({
          ...prevState,
          [preselectedFilterKey]: dataPreFilter[preselectedFilterKey],
        }));
      }
    }
  }, []);



  //--- Test if there's is a marker to display at page loading
  let displayMap = true;
  useEffect(() => {
    if (filteredEntities.length > 0) {
      displayMap = true;
    } else {
      displayMap = false;
    }
  }, []);

  //--- Dynamic Import
  const InstitutionInfos = clientComponent["InstitutionInfos"];
  const filterBehaviour = clientComponent["filterBehaviour"];
  const GenericFilter = clientComponent["GenericFilter"];
  const MapHeader = clientComponent["MapHeader"];
  // let Sidebar = null
  // if (process.env.REACT_APP_SIDEBAR_GEOSEARCH === "true") {
  //   Sidebar = clientComponent["Sidebar"]
  // }
  // const Sidebar = clientComponent["Sidebar"]

  //--- Gestion du comportement des filtres - ajouter l'import dynamique selon le client
  useEffect(() => {
    filterBehaviour(
      filteredData,
      filtersState,
      filtersKeys,
      setFilteredEntities,
      searchState,
      mapRef,
      selectedGeoAdress,
      data.filters
    );
  }, [filtersState, searchState, selectedGeoAdress]);

  //--- Trigered by mobile button,
  const closeMapScreen = () => {
    document.body.classList.remove("no-scroll");
    setMapScreen(false);
    setSelectedInstitution(null);
  };

  // --- Reset selected institution on research input
  useEffect(() => {
    setSelectedInstitution(null);
  }, [searchState]);


  const EmptyDataCoord = () => {
    return (
      <div className="overlay-empty-data-container">
        {/* // TODO: add svg */}
        <span>Aucune coordonnées trouvées</span>
      </div>

    )
  };

  return (
    <>
      {displayMap && (
        <div className="glanum-leaflet__wrapper">
          {process.env.REACT_APP_MAPHEADER === "true" && mapScreen === false && (
            <MapHeader
              locationSearch={locationSearch}
              setLocationSearch={setLocationSearch}
              setFilterScreen={setFilterScreen}
              setShowFiltersFrom={setShowFiltersFrom}
              filtersKeys={filtersKeys}
              filtersState={filtersState}
              userCurrentPosition={userCurrentPosition}
              setUserCurrentPosition={setUserCurrentPosition}
              setGeoSearch={setGeoSearch}
              geoSearch={geoSearch}
              setSelectedGeoAdress={setSelectedGeoAdress}
              searchState={searchState}
              setSearchState={setSearchState}
              mapScreen={mapScreen}
              sizeState={sizeState}
              logoUrl={data.logo}
              isFocused={isFocused}
              setIsFocused={setIsFocused}
              townDefaultValue={townDefaultValue}
            />
          )}
          <div
            className="glanum-leaflet__content"
            style={{ zIndex: filterScreen ? 1900 : "" }}
          >
            {process.env.REACT_APP_SIDEBAR !== "none" && (
              <div
                className={`sidebar ${process.env.REACT_APP_SIDEBAR === "right"
                  ? "sidebar--right"
                  : ""
                  }`}
              >
                {/* // TODO ::  check upgrade */}
                {process.env.REACT_APP_SIDEBAR_GEOSEARCH === "true" ? (
                  <Sidebar
                    data={data}
                    filteredEntities={filteredEntities}
                    setFilteredEntities={setFilteredEntities}
                    selectedInstitution={selectedInstitution}
                    setSelectedInstitution={setSelectedInstitution}
                    filtersState={filtersState}
                    setFiltersState={setFiltersState}
                    filtersKeys={filtersKeys}
                    searchState={searchState}
                    setSearchState={setSearchState}
                    filterScreen={filterScreen}
                    setFilterScreen={setFilterScreen}
                    mapScreen={mapScreen}
                    setMapScreen={setMapScreen}
                    setScrollbarRef={setScrollbarRef}
                    lineRefs={lineRefs}
                    showFiltersFrom={showFiltersFrom}
                    setShowFiltersFrom={setShowFiltersFrom}
                    // new args
                    locationSearch={locationSearch}
                    setLocationSearch={setLocationSearch}
                    userCurrentPosition={userCurrentPosition}
                    setUserCurrentPosition={setUserCurrentPosition}
                    setGeoSearch={setGeoSearch}
                    geoSearch={geoSearch}
                    setSelectedGeoAdress={setSelectedGeoAdress}
                  />
                ) : (
                  <Sidebar
                    data={data}
                    filteredEntities={filteredEntities}
                    setFilteredEntities={setFilteredEntities}
                    selectedInstitution={selectedInstitution}
                    setSelectedInstitution={setSelectedInstitution}
                    filtersState={filtersState}
                    setFiltersState={setFiltersState}
                    filtersKeys={filtersKeys}
                    searchState={searchState}
                    setSearchState={setSearchState}
                    filterScreen={filterScreen}
                    setFilterScreen={setFilterScreen}
                    mapScreen={mapScreen}
                    setMapScreen={setMapScreen}
                    setScrollbarRef={setScrollbarRef}
                    lineRefs={lineRefs}
                    showFiltersFrom={showFiltersFrom}
                    setShowFiltersFrom={setShowFiltersFrom}
                  />)}
              </div>
            )}
            <div
              className={`map__wrapper ${mapScreen === true ? "active" : ""
                } flex-grow-1`}
            >
              {
                mapScreen && process.env.REACT_APP_BTN_MOBILE_POSITION === "top" &&
                <div className="sidebar-to-map__btn-top-wrapper">
                  <button
                    className={`sidebar-to-map__btn-top ${!mapScreen ? "selected" : ""} ${selectedInstitution &&
                      process.env.REACT_APP_INSTITUTIONLAYER === "true" ? "active" : ""}`}
                    onClick={() => closeMapScreen()}>
                    {t("displayList")}
                  </button>
                  <button
                    className={`sidebar-to-map__btn-top ${!mapScreen ? "" : "selected"} ${selectedInstitution &&
                      process.env.REACT_APP_INSTITUTIONLAYER === "true"
                      ? "active"
                      : ""
                      }`}>
                    {t("displayMap")}
                  </button>
                </div>
              }
              {
                !process.env.REACT_APP_OVERLAY_HEADER ? null : (
                  <OverlayHeader
                    title={data.filterSectionTitle}
                    setMapScreen={setMapScreen}
                    setFilterScreen={setFilterScreen}
                    setSelectedInstitution={setSelectedInstitution}
                    filtersKeys={filtersKeys}
                    filtersState={filtersState}
                    setShowFiltersFrom={setShowFiltersFrom}
                  />
                )
              }
              {/* {
                data.entities.length === 0 && <div className="overlay-empty-data-container"><span>Aucun bien ne correspond à votre recherche</span></div>
              }
              {
                data.entities.length !== 0 && filteredEntities.length === 0 && <EmptyDataCoord />
              } */}
              <Map
                data={filteredEntities}
                selectedInstitution={selectedInstitution}
                setSelectedInstitution={setSelectedInstitution}
                client={process.env.REACT_APP_CLIENT}
                filtersKeys={filtersKeys}
                filters={data.filters}
                scrollbarRef={scrollbarRef}
                lineRefs={lineRefs}
                customMarkerRefs={customMarkerRefs}
                popupRefs={popupRefs}
                mapRef={mapRef}
                setMapRef={setMapRef}
                sizeState={sizeState}
                userCurrentPosition={userCurrentPosition}
                selectedGeoAdress={selectedGeoAdress}
                setFilteredEntities={setFilteredEntities}
                legende={legende}
              />
              {mapScreen && !process.env.REACT_APP_BTN_MOBILE_POSITION && (
                <button
                  className={`map-to-list__btn ${selectedInstitution &&
                    process.env.REACT_APP_INSTITUTIONLAYER === "true"
                    ? "active"
                    : ""
                    }`}
                  onClick={() => closeMapScreen()}
                >
                  {t("displayList")}
                </button>
              )}
              {selectedInstitution &&
                process.env.REACT_APP_INSTITUTIONLAYER === "true" && (
                  <InstitutionInfos
                    selectedInstitution={selectedInstitution}
                    setSelectedInstitution={setSelectedInstitution}
                    filters={data.filters}
                  />
                )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default GlanumLeaflet;
